import Image from './container'

export default Image
